<template>
  <section class="hero section center-content" :class="[hasBgColor && 'has-bg-color', invertColor && 'invert-color']">
    <div class="container-sm">
      <div class="hero-inner section-inner" :class="[topDivider && 'has-top-divider', bottomDivider && 'has-bottom-divider']">
        <div class="hero-content">
          <h1 class="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="200">
            Our Partners
          </h1>
          <div class="container-xs">
            <p class="m-0 mb-32 reveal-from-bottom" data-reveal-delay="400">
              We're always looking for new partners, apply via the button below.
            </p>
            <div class="reveal-from-bottom" data-reveal-delay="600">
              <c-button tag="a" color="primary">
                COMING SOON!
              </c-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionProps } from '@/utils/SectionProps.js';
import CButton from '@/components/elements/Button.vue';

export default {
  name: 'CPartnersHero',
  mixins: [SectionProps],
  components: {
    CButton
  }
};
</script>
